export function getIEVersion() {
    var ieVersion=false;
    var browser=navigator.appName;
    if(browser!=="Microsoft Internet Explorer"){
        return ieVersion;
    }
    var b_version=navigator.appVersion
    var version=b_version.split(";");
    var trim_Version=version[1].replace(/[ ]/g,"");
    if(browser=="Microsoft Internet Explorer" && trim_Version=="MSIE6.0")
    {
        ieVersion=6;
    }
    else if(browser=="Microsoft Internet Explorer" && trim_Version=="MSIE7.0")
    {
        ieVersion=7;
    }
    else if(browser=="Microsoft Internet Explorer" && trim_Version=="MSIE8.0")
    {
        ieVersion=8;
    }
    else if(browser=="Microsoft Internet Explorer" && trim_Version=="MSIE9.0")
    {
        ieVersion=9;
    }
    else if(browser=="Microsoft Internet Explorer" && trim_Version=="MSIE10.0")
    {
        ieVersion=10;
    }
    else if(browser=="Microsoft Internet Explorer" && trim_Version=="MSIE11.0")
    {
        ieVersion=11;
    }
    return ieVersion;

}




// WEBPACK FOOTER //
// ./src/common/js/getIEVersion.js